"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ListCard_1 = __importDefault(require("@pbl/pbl-react-web-components/lib/card/ListCard"));
var package_1 = require("@pbl/pbl-react-web-components/lib/package");
var react_1 = __importDefault(require("react"));
var constants_1 = __importDefault(require("../../../config/constants"));
var RewardCard = function (_a) {
    var reward = _a.reward, banner = _a.banner, onPress = _a.onPress, preview = _a.preview;
    var cornerIcon = {
        icon: 'icon-KS-rewards',
        iconType: 'custom',
        contentColor: banner && banner.styleType && banner.styleType === 'GrayedOut'
            ? package_1.config.themeColors.black.alpha(0.35).toString()
            : package_1.config.themeColors.cornerColors.rewardContrast.hex(),
        trianglePosition: { top: 0, left: 0 },
        triangleType: 'topLeft',
        triangleBackgroundColor: banner && banner.showBanner && banner.styleType === 'GrayedOut'
            ? package_1.config.themeColors.white.toString()
            : package_1.config.themeColors.cornerColors.reward.hex(),
        triangleSize: 88
    };
    return (react_1.default.createElement(ListCard_1.default, { onClick: onPress, image: reward.imageUrl, imageTitle: reward.title, text: reward.title, textDescription: preview, title: "Redeem for: ".concat(reward.amount.toPointsFormatWithUnit().toUpperCase()), cornerIcon: constants_1.default.DISABLE_REWARDS_CORNER_ICON ? undefined : cornerIcon, showBanner: banner && banner.showBanner, bannerText: banner && banner.bannerText ? banner.bannerText : undefined, bannerStyleType: banner && banner.styleType ? banner.styleType : undefined }));
};
exports.default = RewardCard;
//# sourceMappingURL=RewardCard.js.map